<template>
    <svg class="text-primary" xmlns="http://www.w3.org/2000/svg" width="32.192" height="32" viewBox="0 0 32.192 32">
        <path d="M40.192,24.1A16.1,16.1,0,1,0,21.581,40V28.751H17.492V24.1h4.089V20.551c0-4.034,2.4-6.262,6.08-6.262a24.77,24.77,0,0,1,3.6.314v3.959h-2.03a2.327,2.327,0,0,0-2.623,2.514V24.1h4.464l-.714,4.653h-3.75V40A16.1,16.1,0,0,0,40.192,24.1Z" transform="translate(-8 -8)" class="fill-current"/>
    </svg>
</template>